export default __webpack_public_path__ + "images/cdef51b85664015074e99f5e130d55b4-building_confidence_developing_I_am_statements.svg";